import { Type } from '../Type';
export class DataList extends Array {
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.type = Type.List;
        this.tags = tags;
        this.logicalType = logicalType;
    }
    static get [Symbol.species]() {
        return Array;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YUxpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL2xpc3QvRGF0YUxpc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUc5QixNQUFNLE9BQU8sUUFBUyxTQUFRLEtBQWU7SUFLM0MsWUFDRSxTQUFxQixFQUFFLEVBQ3ZCLFdBQXlCLEVBQ3pCLElBQWU7UUFFZixLQUFLLENBQUMsR0FBRyxNQUFNLENBQUMsQ0FBQTtRQVRULFNBQUksR0FBUyxJQUFJLENBQUMsSUFBSSxDQUFBO1FBVTdCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFBO0lBQ2hDLENBQUM7SUFFRCxNQUFNLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDO1FBQ3pCLE9BQU8sS0FBSyxDQUFBO0lBQ2QsQ0FBQztDQUNGIn0=